"use client";

import { c as _c } from "react/compiler-runtime";
import { formatDate, setHours, setMinutes } from "date-fns";
import { useState } from "react";
import { Schedule } from "../../icons";
import { classNames } from "../../utils";
import { DatePicker } from "../DatePicker";
import { FlexCenter } from "../FlexCenter";
import { Input } from "../Input";
const HTML_TIME_INPUT = "HH:mm";
export function DateTimePicker(t0) {
  const $ = _c(43);
  const {
    className,
    overrides,
    selected,
    onSelect,
    size: t1,
    format: formatFn,
    placeholder,
    disabled,
    error,
    portal
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const iconSize = size === "lg" ? 24 : size === "xs" ? 16 : 20;
  let t2;
  if ($[0] !== selected) {
    t2 = selected ? formatDate(selected, HTML_TIME_INPUT) : "00:00";
    $[0] = selected;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [time, setTime] = useState(t2);
  const updateDateWithTime = _temp;
  const disabledInput = typeof disabled === "boolean" && disabled;
  let t3;
  if ($[2] !== className) {
    t3 = classNames("gap-4", className);
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onSelect || $[5] !== time) {
    t4 = date_0 => {
      if (!date_0) {
        return;
      }
      const updatedDate = time ? updateDateWithTime(date_0, time) : date_0;
      onSelect?.(updatedDate);
    };
    $[4] = onSelect;
    $[5] = time;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = overrides?.DatePicker;
  let t6;
  if ($[7] !== disabled || $[8] !== error || $[9] !== formatFn || $[10] !== placeholder || $[11] !== portal || $[12] !== selected || $[13] !== size || $[14] !== t4 || $[15] !== t5) {
    t6 = <DatePicker disabled={disabled} error={error} format={formatFn} onSelect={t4} placeholder={placeholder} portal={portal} selected={selected} size={size} {...t5} />;
    $[7] = disabled;
    $[8] = error;
    $[9] = formatFn;
    $[10] = placeholder;
    $[11] = portal;
    $[12] = selected;
    $[13] = size;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== iconSize) {
    t7 = <Schedule size={iconSize} />;
    $[17] = iconSize;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== onSelect || $[20] !== selected) {
    t8 = e => {
      const time_1 = e.target.value;
      setTime(time_1);
      if (!selected) {
        return;
      }
      const updatedDate_0 = updateDateWithTime(selected, time_1);
      onSelect?.(updatedDate_0);
    };
    $[19] = onSelect;
    $[20] = selected;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const t9 = overrides?.TimeInput?.overrides?.Input;
  const t10 = overrides?.TimeInput?.overrides?.Input?.className;
  let t11;
  if ($[22] !== t10) {
    t11 = classNames("font-mono [&::-webkit-calendar-picker-indicator]:hidden", t10);
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = {
      Input: {
        ...t9,
        className: t11
      }
    };
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = overrides?.TimeInput;
  const t14 = overrides?.TimeInput?.className;
  let t15;
  if ($[27] !== t14) {
    t15 = classNames("w-fit", t14);
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== disabledInput || $[30] !== error || $[31] !== size || $[32] !== t12 || $[33] !== t13 || $[34] !== t15 || $[35] !== t7 || $[36] !== t8 || $[37] !== time) {
    t16 = <Input disabled={disabledInput} endEnhancer={t7} error={error} onChange={t8} overrides={t12} size={size} type="time" value={time} {...t13} className={t15} />;
    $[29] = disabledInput;
    $[30] = error;
    $[31] = size;
    $[32] = t12;
    $[33] = t13;
    $[34] = t15;
    $[35] = t7;
    $[36] = t8;
    $[37] = time;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t16 || $[40] !== t3 || $[41] !== t6) {
    t17 = <FlexCenter className={t3}>{t6}{t16}</FlexCenter>;
    $[39] = t16;
    $[40] = t3;
    $[41] = t6;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  return t17;
}
function _temp(date, time_0) {
  const [hours, minutes] = time_0.split(":").map(Number);
  return setMinutes(setHours(date, hours), minutes);
}